import { GatewayControleQuinquennal } from "@conformite/gateway";
import { ControleQuinquennalStatus } from "@gateway/controle-quinquennal/controller/controle-quinquennal.definition";
import {
  AXE_STATUS_MAP,
  getControleQuinquennalDateButoir,
  TICKET_STATUS_MAP,
} from "@src/helper/ticket.helper";
import { format } from "date-fns";

type AxeType = GatewayControleQuinquennal.ControleQuinquennalAxeType;

const AXE_TYPE_LABELS: Record<AxeType, string> = {
  ASSUJETTI: "Axe - Assujetti",
  RCPRO_COA: "Axe - RC Pro COA",
  RCPRO_MIA: "Axe - RC Pro MIA",
  RCPRO_COBSP: "Axe - RC Pro COBSP",
  RCPRO_MIOBSP: "Axe - RC Pro MIOBSP",
  GARANTIE_FINANCIERE_IAS: "Axe - Garantie Financière IAS",
  GARANTIE_FINANCIERE_IOBSP: "Axe - Garantie Financière IOBSP",
};

const AXE_TYPES_ORDER = [
  "ASSUJETTI",
  "RCPRO_COA",
  "RCPRO_MIA",
  "RCPRO_COBSP",
  "RCPRO_MIOBSP",
  "GARANTIE_FINANCIERE_IAS",
  "GARANTIE_FINANCIERE_IOBSP",
] as AxeType[];

const CQ_STATUS_LABELS: Record<ControleQuinquennalStatus, string> = {
  [ControleQuinquennalStatus.EN_COURS]: "En cours",
  [ControleQuinquennalStatus.DEPOSE]: "Déposé",
  [ControleQuinquennalStatus.TERMINE]: "Terminé",
  [ControleQuinquennalStatus.ANNULE]: "Annulé",
};

export const CSV_HEADERS = [
  "ID Ticket",
  "Phase du cycle de vie",
  "Contact admin",
  "Chiffre d'affaires",
  "Nombre de personnes assujetties",
  "Mandants",
  "Entreprise parent",
  "ID Entreprise",
  "Entreprise",
  "SIREN",
  "Numéro ORIAS",
  "Activités accessoires",
  "Activités ORIAS",
  "Millésime",
  "Vérificateur propriétaire du ticket CQ",
  "Date de début",
  "État HubSpot",
  "Statut interne",
  "Date de fin",
  "Date rapport final",
  "Date de dépôt",
  "Date première remédiation",
  "Date butoir",
  ...AXE_TYPES_ORDER.map((t) => AXE_TYPE_LABELS[t]),
];

export const mapCQToExportRow = (
  row: GatewayControleQuinquennal.ControleQuinquennalAdminExportResponse
): (string | null)[] => {
  const dateButoir = getControleQuinquennalDateButoir(row);

  const axeStatusByType = Object.fromEntries(
    (row.controleQuinquennalAxes ?? []).map((axe) => [axe.type, axe.status])
  );

  return [
    row.idTicket ?? "-",
    row.phaseCycleDeVie ?? "-",
    row.contactAdmin ?? "-",
    row.chiffreAffaire != null ? String(row.chiffreAffaire) : "-",
    row.nombrePersonnesAssujetties != null
      ? String(row.nombrePersonnesAssujetties)
      : "-",
    row.mandants ?? "-",
    row.entrepriseParent ?? "-",
    row.idEntreprise,
    row.entrepriseName,
    row.siren ?? "-",
    row.numeroOrias ?? "-",
    row.activitesAccessoires ?? "-",
    row.activitesOrias ?? "-",
    String(row.millesime),
    row.verificateurProprietaireTicketCq ?? "-",
    format(new Date(row.dateDebut ?? row.dateCreation), "dd/MM/yyyy"),
    TICKET_STATUS_MAP[row.pipelineStage]?.label ?? row.pipelineStage ?? "-",
    CQ_STATUS_LABELS[row.status] ?? row.status,
    row.dateFin ? format(new Date(row.dateFin), "dd/MM/yyyy") : "-",
    row.dateRapportFinal
      ? format(new Date(row.dateRapportFinal), "dd/MM/yyyy")
      : "-",
    row.dateDepot
      ? format(new Date(row.dateDepot), "dd/MM/yyyy")
      : "-",
    row.datePremiereRemediation
      ? format(new Date(row.datePremiereRemediation), "dd/MM/yyyy")
      : "-",
    dateButoir ? format(dateButoir, "dd/MM/yyyy") : "-",
    ...AXE_TYPES_ORDER.map((type) => {
      const status = axeStatusByType[type];
      return status ? AXE_STATUS_MAP[status].label : "-";
    }),
  ];
};
